import { Center, Flex, Icon } from "@chakra-ui/react"
import * as gqlTypes from "@hydrologiq/gql/graphql"
import { FaMap } from "react-icons/fa6"
import { Link } from "react-router-dom"
import { Tooltip } from "../chakra/Tooltip"

const Location = (props: {
  name?: string
  location?: gqlTypes.Location | null
  asset?: gqlTypes.Asset
  edit?: boolean
  editComponent?: React.ReactNode
  background?: boolean
  larger?: boolean
}) => {
  const { name, location, asset, edit = false, editComponent, background = true, larger = false } = props

  const locationName = name ? name : location ? location.name || `${location.lat},${location.long}` : "no location"

  return (
    <Flex
      justifyContent={"space-between"}
      alignItems={"center"}
      flexDirection={"row"}
      width={larger ? "100%" : "fit-content"}
      maxWidth={larger ? "100%" : 180}
      height={larger ? "2rem" : "auto"}
      borderRadius={"md"}
      px={background ? 2 : 0}
      py={background ? "0.125rem" : 0}
      mt={larger ? "0.5rem" : 0}
      backgroundColor={background ? "gray.100" : "transparent"}
      border={background ? "0.0625rem solid" : "none"}
      borderColor={"gray.200"}
    >
      <Tooltip content={locationName}>
        <Center textAlign={"left"} mr={2} lineHeight={"1.2"} fontSize={"xs"} color={"gray.700"} overflow={"hidden"} whiteSpace={"nowrap"} textOverflow={"ellipsis"}>
          {locationName}
        </Center>
      </Tooltip>

      <Flex flexDirection={"row"} gap={1} alignItems={"center"}>
        {location && (
          <Center>
            <Link
              to={`https://www.google.com/maps/place/${location.lat},${location.long}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="primary"
            >
              <Icon as={FaMap} color={"cyan.500"} boxSize={3.5} />
            </Link>
          </Center>
        )}
        <Center>{asset && edit && editComponent && editComponent}</Center>
      </Flex>
    </Flex>
  )
}

export default Location
